module.exports = __webpack_public_path__ + "static/media/girl-23.d4673022.svg";